import React, { useMemo } from 'react';
import { getAllStates } from '@dill/dill-shared/dist/src';
import { DillDropdown } from '../../../general/Dill';

const StateDropDown = ({
  errorText = '',
  label = 'State',
  isRequired,
  value,
  onTextChange,
  wrapperClassName = '',
  containerClassName = 'h-[42px]',
  labelTextClassName = 'text-wrap',
}: {
  errorText?: string;
  label?: string;
  isRequired: boolean;
  value: string;
  onTextChange: (props: any) => void;
  wrapperClassName?: string;
  containerClassName?: string;
  labelTextClassName?: string;
}) => {
  const allStates = useMemo(() => {
    return getAllStates();
  }, []);

  return (
    <div className={`w-full ${wrapperClassName}`}>
      <DillDropdown
        isRequired={isRequired}
        label={label}
        value={value}
        errorText={errorText}
        labelTextClassName={`${labelTextClassName}`}
        containerClassName={`${containerClassName}`}
        tabToNextFieldOnClose
        items={[
          ...Object.keys(allStates).map((state) => {
            const key = state as keyof typeof allStates;
            const stateKey = allStates[key];
            return {
              label: `${stateKey} - ${state}`,
              value: stateKey,
            };
          }),
        ]}
        onSelectChange={(item) => {
          if (item && item?.value !== null) {
            const foundState = Object.values(getAllStates()).find((state) => state === item?.value);
            if (foundState) {
              onTextChange(item.value);
            }
          }
        }}
      />
    </div>
  );
};

export default StateDropDown;
